

const GRANTING = {
    items: [
        { field: "txt22", value: "4", notAllowed: true }
    ]
}

export const verifyGrantingList = ({ elements, cfName }) => {
    if (GRANTING[`${cfName}`] && GRANTING[`${cfName}`].length > 0) {
        let tmpElements = [...elements];
        GRANTING[`${cfName}`].forEach(item => {
            if (item.notAllowed) {
                if (elements && elements.length > 0) {
                    tmpElements = tmpElements.filter(el => {
                        if (el.metadata && el.metadata.fields
                            && el.metadata.fields[item.field]
                            && el.metadata.fields[item.field] == item.value) {
                            return false;
                        }
                        return true;
                    });
                }
            }
        });
        return tmpElements;
    }
    return elements;
}

export const verifyGranting = ({ el, cfName }) => {
    if (GRANTING[`${cfName}`] && GRANTING[`${cfName}`].length > 0) {
        let tmp = el;
        GRANTING[`${cfName}`].forEach(item => {
            if (item.notAllowed) {
                if (el && el.metadata && el.metadata.fields
                    && el.metadata.fields[item.field]
                    && el.metadata.fields[item.field] == item.value) {
                    tmp = null;
                    console.log("LOGS: Not allowed to get Item!");
                }
            }
        });
        return tmp;
    }
    return el;
}